import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { isArray, isEmpty, isUndefined } from 'lodash';
import qs from 'querystring';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input, Hidden } from '~/components/Form';
import { ConfirmationDialogRaw } from '~/components';
import { t } from '~/helpers';
import api from '~/services/api';
import { FormWrapper } from './styles';

import * as S from './styles';

export default function MyForm({ data, reference, close, cancelarAcao }) {

  const [isLoading, setIsLoading] = useState(false);

  const { profile } = useSelector((state) => state.user);

  const [valueMsg, setValueMsg] = React.useState('');

  //ConfirmationDialogRaw o registro do geral
  const [tituloConfirmationDialogRaw, setTituloConfirmationDialogRaw] = React.useState('Contestar pré-fatura GFE!');
  const [mensagemConfirmationDialogRaw, setMensagemConfirmationDialogRaw] = React.useState('Deseja confirmar a operação?');
  const [openConfirmationDialogRaw, setOpenConfirmationDialogRaw] = React.useState(false);
  const [valueConfirmationDialogRaw, setValueConfirmationDialogRaw] = React.useState("CLICK-OK");
  const [paramSubmit, setParamSubmit] = React.useState();


  const execHandleConfirmar = async (param) => {
    setParamSubmit(param);
    setOpenConfirmationDialogRaw(true);
  };

  const handleConfirmationDialogRaw = (newValue) => {
    //console.log(newValue);
    setOpenConfirmationDialogRaw(false);
    if (newValue) {
      setValueConfirmationDialogRaw(newValue);
      setIsLoading(false);
      if (newValue === 'CLICK-OK') {
        setIsLoading(true);
        handleSubmit(paramSubmit)
      }
    } else {
      cancelarAcao();
      setIsLoading(false);
    }

  };

  async function handleSubmitPegunta(param) {
    await setIsLoading(true);
    await execHandleConfirmar(param);
  }


  async function handleSubmit(param) {
    try {
      let sparam = {
        ...param
      }

      const schema = Yup.object().shape({
        username: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, 'Este campo deve ter no mínimo 1 caractere(s)')
          .max(20, 'Este campo deve ter no maximo 20 caractere(s)'),
        password: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, 'Este campo deve ter no mínimo 1 caractere(s)')
          .max(20, 'Este campo deve ter no maximo 20 caractere(s)'),
        msg: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, 'Este campo deve ter no mínimo 1 caractere(s)')
          .max(1000, 'Este campo deve ter no maximo 20 caractere(s)'),

      });

      await schema.validate(sparam, {
        abortEarly: false,
      });

      try {
        const wherefield = [];
        const valuewherefield = [];
        const typewherefield = [];
        wherefield.push('usua_login');
        valuewherefield.push(param.username);
        typewherefield.push("IGUAL");
        const search = { wherefield, valuewherefield, typewherefield };
        const { data } = await api.get('/usuariomaster', {
          params: { ...search, pagesize: 99999, pesquisalista: true, page: 1, },
          paramsSerializer: (param) => qs.stringify(param),
        });
        const { items } = data;
        if (!isEmpty(items)) {

          let glousuariologin = profile.glousuariologin;
          if (isUndefined(glousuariologin)) {
            glousuariologin = param.username;
          }
          if ((String(glousuariologin).trim().toUpperCase()) !== (String(param.username).trim().toUpperCase())) {
            toast.error('O login informado é diferente do que foi utilizado para acessar o sistema!');
            return;
          }


          if (param.password !== items[0].usua_senha) {
            toast.error('Falha na autenticação do usuário! Login ou senha inválidos!');
            return;
          }
          if (items[0].usua_aprova_pre_faturamento === 'N') {
            toast.error('Falha na autenticação do usuário! Sem permissão para essa operação!');
            return;
          }
          if (items[0].usua_status !== 1) {
            toast.error('Falha na autenticação do usuário! Usuário bloqueado!');
            return;
          }
          if (items[0].perf_status !== 1) {
            toast.error('Falha na autenticação do usuário! Usuário bloqueado!');
            return;
          }
        } else {
          toast.error('Falha na autenticação do usuário! Login ou senha inválidos!');
          return;
        }
      } catch (err) {
        if (isArray(err)) {
          err.map((e) => toast.error(e));
        }
      }



      const faturamentoseparados = [
        {
          fatu_codigo: param.fatu_codigo,
          orga_codigo: param.orga_codigo,
          orga_nome: param.orga_nome,
          fatu_uuid: param.fatu_uuid
        }];

      const objSend = {
        faturamentoseparados: faturamentoseparados,
        msg: param.msg,
        username01: param.username,
        password01: param.password,
        username02: param.username,
        password02: param.password,
      };

      await api.put('radadmdadosfaturamentoseplag/contestacaoprefaturapelogfe', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      await cancelarAcao();

      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>

      <> {/* <> Para confirmação do form */}
        <ConfirmationDialogRaw
          id="ringtone-menu-confirmar"
          keepMounted
          open={openConfirmationDialogRaw}
          onClose={handleConfirmationDialogRaw}
          valueProp={valueConfirmationDialogRaw}
          mensagem={mensagemConfirmationDialogRaw}
          titulo={tituloConfirmationDialogRaw}
          textoBtnOK="Sim"
          textoBtnCancel="Não"
        />
      </> {/* <> Para confirmação do form */}

      <S.Wrapper>
        <FormWrapper ref={reference} initialData={data} onSubmit={(event) => handleSubmitPegunta(event)}>
          <Input
            name="fatu_codigo"
            label="Número da Pré-Fatura:"
            disabled
          />
          <Input
            name="orga_completo"
            label="Órgão:"
            disabled
          />
          <Input
            name="orga_cgc"
            label="CNPJ:"
            disabled
          />
          <S.WrapperCab>
            <Input
              name="username"
              label="Login"
              required
              size="medium"
            />
            <Input
              type="password"
              name="password"
              label="Senha"
              required
              size="medium"
            />
          </S.WrapperCab>
          <Input
            name="msg"
            label="Mensagem"
            size="medium"
            multiline
            required
            rows={20}
            inputProps={{ maxLength: 1000 }}
            fullWidth
            getValue={(value) => setValueMsg(value)}
          />
          <p>{valueMsg.length}/1000 caracteres</p> {/* Mostra a contagem de caracteres */}

          <Hidden name="orga_codigo" />
          <Hidden name="orga_nome" />
          <Hidden name="fatu_uuid" />
        </FormWrapper>
      </S.Wrapper>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
  cancelarAcao: PropTypes.func.isRequired,
};
